import { Price } from '@/shared/types/Billing';

export type RegistrationSurveyEventData = {
  [key: string]: boolean | string;
};
export type ViewItemListItems = {
  item_id: Price['id'];
  item_name: string;
  price: number;
  quantity: number;
};
export enum ViewItemList {
  Minutes = 'Minutes',
  Plan = 'Plan',
}
type EcommerceViewItemListEventData = {
  items: ViewItemListItems[];
  view_item_list: ViewItemList;
};
export type ViewItemListEventData = {
  ecommerce: EcommerceViewItemListEventData;
};
type EcommerceBeginCheckoutEventData = {
  items: [
    {
      item_id: string;
      item_name: string;
      price: number;
      quantity: number;
    },
  ];
  currency: string;
  value: number;
};
export type BeginCheckoutEventData = {
  ecommerce: EcommerceBeginCheckoutEventData;
};
